module.exports = __webpack_public_path__ + "name=img/src/assets/emoji/rocket.png?40ba25d32edd03f1650a0952f1a1c000";